var _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgWarningBlue(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 16,
    height: 16,
    viewBox: "0 0 16 16",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M7.33333 5.99998C7.33333 5.63198 7.632 5.33331 8 5.33331C8.368 5.33331 8.66667 5.63198 8.66667 5.99998V8.66665C8.66667 9.03465 8.368 9.33331 8 9.33331C7.632 9.33331 7.33333 9.03465 7.33333 8.66665V5.99998ZM7.33333 10.6666C7.33333 10.2986 7.632 9.99998 8 9.99998C8.368 9.99998 8.66667 10.2986 8.66667 10.6666C8.66667 11.0346 8.368 11.3333 8 11.3333C7.632 11.3333 7.33333 11.0346 7.33333 10.6666ZM13.9098 12.2353C13.7571 12.5053 13.4598 12.6666 13.1145 12.6666H2.88513C2.5398 12.6666 2.24247 12.5053 2.09047 12.2353C2.01847 12.1086 1.9238 11.8506 2.1018 11.5573L7.2158 3.07865C7.52713 2.56265 8.47247 2.56265 8.7838 3.07865L13.8985 11.5573C14.0758 11.8506 13.9818 12.1086 13.9098 12.2353ZM15.0405 10.8686L9.9258 2.38931C9.52647 1.72798 8.80647 1.33331 7.9998 1.33331C7.19313 1.33331 6.47313 1.72798 6.07447 2.38931L0.959799 10.8686C0.580466 11.4973 0.569133 12.2533 0.929132 12.8906C1.31513 13.5753 2.06513 14 2.88513 14H13.1145C13.9351 14 14.6845 13.5753 15.0711 12.8906C15.4311 12.2533 15.4198 11.4973 15.0405 10.8686Z",
    fill: "#00A0F3"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgWarningBlue);
export default __webpack_public_path__ + "static/media/WarningBlue.e47cd2068b071c34118e7e1817f12823.svg";
export { ForwardRef as ReactComponent };